import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import LeftPanel from 'Views/Page/Content/Templates/GeneratedViewTemplate/LeftPanel';
import MainPanel from './MainPanel';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  left: {
    flexShrink: 0,
    width: theme.dimensions.sm,
  },
  main: {
    flexGrow: 1,
  },
});

const LinkedAccountErrorViewTemplate = ({
  className,
  classes,
}) => {
  return (
    <div className={classNames(className, classes.root)}>
      <LeftPanel className={classes.left} />
      <MainPanel className={classes.main} />
    </div>
  );
};

LinkedAccountErrorViewTemplate.defaultProps = {
  className: '',
};

LinkedAccountErrorViewTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinkedAccountErrorViewTemplate);
